export type SystemFieldTypes =
	| 'versions'
	| 'approval-panel'
	| 'assignee'
	| 'components'
	| 'created'
	| 'description'
	| 'duedate'
	| 'ecosystemContext'
	| 'ecosystemGlance'
	| 'environment'
	| 'fixVersions'
	| 'forgeContext'
	| 'forgeCustomField'
	| 'forgeGlance'
	| 'issuelinks'
	| 'issuerestriction'
	| 'issuetype'
	| 'labels'
	| 'parent'
	| 'priority'
	| 'proforma-forms'
	| 'releases'
	| 'reporter'
	| 'resolutiondate'
	| 'resolution'
	| 'security'
	| 'servicedesk-approvals'
	| 'servicedesk-incident-management'
	| 'servicedesk-practices'
	| 'status'
	| 'subtasks'
	| 'summary'
	| 'timeoriginalestimate'
	| 'timetracking'
	| 'updated'
	| 'votes'
	| 'watches';

export type CustomFieldTypes =
	| 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list'
	| 'com.atlassian.servicedesk.assets-plugin:assetfield'
	| 'com.atlassian.jpo:jpo-custom-field-baseline-end'
	| 'com.atlassian.jpo:jpo-custom-field-baseline-start'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
	| 'com.atlassian.graphql:children-issues'
	| 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype'
	| 'com.pyxis.greenhopper.jira:jsw-issue-color'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:datetime'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
	| 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement'
	| 'com.pyxis.greenhopper.jira:gh-epic-color'
	| 'com.atlassian.graphql:epic-issues'
	| 'com.pyxis.greenhopper.jira:gh-epic-label'
	| 'com.pyxis.greenhopper.jira:gh-epic-status'
	| 'com.pyxis.greenhopper.jira:gh-epic-link'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:flagged'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:labels'
	| 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype'
	| 'com.atlassian.jira.toolkit:message'
	| 'com.atlassian.jira.toolkit:viewmessage'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:float'
	| 'com.atlassian.servicedesk.customer-context:sd-csm-organization'
	| 'com.atlassian.servicedesk:sd-customer-organizations'
	| 'com.atlassian.jpo:jpo-custom-field-parent'
	| 'com.atlassian.jira.toolkit:participants'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:people'
	| 'com.atlassian.graphql:portfolio-child-issues'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:project'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield'
	| 'com.atlassian.servicedesk:sd-request-feedback'
	| 'com.atlassian.servicedesk:sd-request-feedback-date'
	| 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language'
	| 'com.atlassian.servicedesk:sd-request-participants'
	| 'com.atlassian.servicedesk:vp-origin'
	| 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:select'
	| 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype'
	| 'com.pyxis.greenhopper.jira:gh-sprint'
	| 'com.pyxis.greenhopper.jira:jsw-story-points'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team'
	| 'com.atlassian.teams:rm-teams-custom-field-team'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:textarea'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:url'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker'
	| 'SENTIMENT'
	| 'com.atlassian.servicedesk.sentiment:sd-sentiment'
	| 'com.atlassian.jira.plugin.system.customfieldtypes:version';

type FieldSchemaItems =
	| 'string'
	| 'group'
	| 'component'
	| 'issuelinks'
	| 'option'
	| 'sd-asset'
	| 'version'
	| 'sd-customerorganization'
	| 'sd-customerrequesttype'
	| 'service-entity-field'
	| 'user'
	| 'json'
	| 'team'
	| 'option2'
	| 'cmdb-object-field';

// Possible values of renderer in FieldSchema
export const RICH_CONTENT = 'atlassian-wiki-renderer' as const;
export const PLAIN_TEXT = 'jira-text-renderer' as const;
export const FROTHER = 'frother-control-renderer' as const;

type FieldSchemaConfiguration = {
	[key: string]: string;
}[];

// TODO: Clean up after properly defining issue field types
type NonSpecificFieldType = string | null;

// TODO: Use `SupportedFieldTypes` instead of `any` after properly defining issue field types
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface FieldSchema<T = any> {
	// TODO: Use `null` for the falsey case since we can only have one or the other
	custom: T extends CustomFieldTypes ? T : NonSpecificFieldType;
	// TODO: Use `null` for the falsey case since we can only have one or the other
	system: T extends SystemFieldTypes ? T : NonSpecificFieldType;
	type: string;
	configuration?: FieldSchemaConfiguration | null;
	customId?: number | null;
	items?: FieldSchemaItems | null;
	renderer?: string | null;
}
